define(['jQuery'], function($) {
  var isMobile = $('body').data('is-mobile');

  if (isMobile) {
    var mobileMenuCheckboxes = $('[data-fcse-role="navMobileMenuCheckbox"]');
    mobileMenuCheckboxes.on('change', function(event) {
      if ($(event.target).prop('checked')) {
        mobileMenuCheckboxes.each(function(index, element) {
          if (element !== event.target) {
            $(element).prop('checked', null);
          }
        });
      }
    });
    var featuresContainer = $('[data-fcse-role="mobile-features-container"]');
    var featuresMenu = $('[data-fcse-role="mobile-features-menu"]');
    var searchMaskFeature = $('[data-feature-type="feature-searchmask"]', featuresContainer);
    featuresContainer.on('click', '[data-fcse-mobile-role="searchmask-mobile-ok-button"]', function() {
      searchMaskFeature.addClass('is-hidden');
    });
    $('[data-feature-type]', featuresMenu).on('click', function(event) {
      var featureType = $(event.target).data('feature-type');
      if (featureType === 'scroll-to') {
        searchMaskFeature.addClass('is-hidden');
        $('html, body').animate({
          scrollTop: $($(event.target).data('scroll-target')).offset().top
        }, 'slow');
      } else {
        var selector = '[data-feature-type="' + $(event.target).data('feature-type') + '"]';
        $('[data-feature-type]', featuresContainer).filter(':not('+selector+')').addClass('is-hidden');
        $(selector, featuresContainer).toggleClass('is-hidden');
      }
    });
  }
});



// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/common_mobile.js